export default {"src":"/_next/static/media/time.3cb3608c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};